import { render, staticRenderFns } from "./BannerPeople.vue?vue&type=template&id=5f22052a&scoped=true&"
import script from "./BannerPeople.vue?vue&type=script&lang=js&"
export * from "./BannerPeople.vue?vue&type=script&lang=js&"
import style0 from "./BannerPeople.vue?vue&type=style&index=0&id=5f22052a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f22052a",
  null
  
)

export default component.exports